import { httpCreate } from './http';

const http = httpCreate('/srv/rainRedPackage');

export const rainRedPackage = {
	getRainRedPackage(id) {
		return http.get(`/${id}`);
	}
};
